// import { createContext, useContext, useState, useEffect } from "react";

// const PropertyContext = createContext();

// export const useProperty = () => useContext(PropertyContext);

// export const PropertyProvider = ({ children }) => {
//   const [properties, setProperties] = useState([]);

//   // Load from localStorage
//   useEffect(() => {
//     const saved = localStorage.getItem("propertyData");
//     if (saved) setProperties(JSON.parse(saved));
//   }, []);

//   const addProperty = () => {
//     setProperties(prev => [
//       ...prev,
//       {
//         title: "",
//         location: "",
//         category: "",
//         tagline: "",
//         heroImage: null,
//         gallery: [],
//         overview: "",
//         soilType: "",
//         elevation: "",
//         crops: "",
//         yield: "",
//         rainfall: "",
//         features: [],
//         documents: {},
//         landSize: "",
//         roadAccess: "",
//         pricing: "",
//         waterSource: "",
//         legalStatus: "",
//         status: "Available",
//         enableVisit: false
//       }
//     ]);
//   };

//   // ✅ Corrected updateProperty: preserve other fields
//   const updateProperty = (index, key, value) => {
//     setProperties(prev => {
//       const newProperties = [...prev];
//       newProperties[index] = {
//         ...newProperties[index], // Keep existing fields
//         [key]: value            // Update only the key
//       };
//       return newProperties;
//     });
//   };

//   return (
//     <PropertyContext.Provider value={{ properties, addProperty, updateProperty }}>
//       {children}
//     </PropertyContext.Provider>
//   );
// };

// // PropertyContext.js
// import { createContext, useContext, useState, useEffect } from "react";

// const PropertyContext = createContext();

// export const useProperty = () => useContext(PropertyContext);

// export const PropertyProvider = ({ children }) => {
//   const [properties, setProperties] = useState([]);

//   // Load saved properties from localStorage
//   useEffect(() => {
//     const saved = localStorage.getItem("propertyData");
//     if (saved) setProperties(JSON.parse(saved));
//   }, []);

//   const addProperty = () => {
//     setProperties(prev => [
//       ...prev,
//       {
//         title: "",
//         location: "",
//         category: "",
//         tagline: "",
//         heroImage: null,
//         gallery: [],
//         overview: "",
//         soilType: "",
//         elevation: "",
//         crops: "",
//         yield: "",
//         rainfall: "",
//         features: [],
//         documents: {},
//         landSize: "",
//         roadAccess: "",
//         pricing: "",
//         waterSource: "",
//         legalStatus: "",
//         status: "Available",
//         enableVisit: false
//       }
//     ]);
//   };

//   // Update only the key, preserve other fields
// const updateProperty = (index, key, value) => {
//   setProperties(prev => {
//     const newProperties = [...prev];
//     if (key === null) newProperties[index] = value;
//     else newProperties[index] = { ...newProperties[index], [key]: value };
//     return newProperties;
//   });
// };

//   return (
//     <PropertyContext.Provider value={{ properties, addProperty, updateProperty }}>
//       {children}
//     </PropertyContext.Provider>
//   );
// };
// src/context/PropertyContext.js

import { createContext, useContext, useState, useEffect } from "react";

const PropertyContext = createContext();
export const useProperty = () => useContext(PropertyContext);

export const PropertyProvider = ({ children }) => {
  const [properties, setProperties] = useState(() => {
    const saved = localStorage.getItem("propertyData");
    return saved ? JSON.parse(saved) : [];
  });

  useEffect(() => {
    localStorage.setItem("propertyData", JSON.stringify(properties));
  }, [properties]);

  // Add new property
  const addProperty = (newProperty) => {
    const updated = [...properties, newProperty];
    setProperties(updated);
    return updated.length - 1; // return new index
  };

  // Update existing property by index
  const updateProperty = (index, updatedProperty) => {
    const updated = [...properties];
    updated[index] = updatedProperty;
    setProperties(updated);
  };

  return (
    <PropertyContext.Provider value={{ properties, addProperty, updateProperty }}>
      {children}
    </PropertyContext.Provider>
  );
};